import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
const ContractorList = () => {
    const context = useContext(AdminContext)
    const { GetAllContractorList } = context
    const [contractor, setContractorList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    // for sequence entry
      const getContractorList = async () => {
  let data = await GetAllContractorList();
  console.log("data", data);
 
  const sortedData = [...data].sort((a, b) => {
    return new Date(b.Date) - new Date(a.Date);
  });
 
  setContractorList(sortedData);
  setFilteredBills(sortedData);
};
 
    useEffect(() => {
        getContractorList()
    }, [])
    let contractorList = []
    if (contractor.length > 0) {
        contractorList = contractor
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = contractor.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, contractor]);


    // new pagination add 28/08/2026
const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;
 
    if (totalPages <= maxVisiblePages) {
        return Array.from(
            { length: totalPages },
            (_, index) => index + 1
        );
    }
 
    // Starting pages
    if (currentPage <= 3) {
        return [1, 2, 3, 4, 5, "...", totalPages];
    }
 
    // Last pages
    if (currentPage >= totalPages - 2) {
        return [
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
        ];
    }
 
    // Middle pages
    return [
        "...",
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2,
        "...",
        totalPages
    ];
};

// 2/11
const thStyle = {
  padding: "10px",
  position: "sticky",
  top: 0,
  zIndex: 10,
  backgroundColor: "#2D79D9",
  color: "white",
  whiteSpace: "nowrap",
  borderBottom: "1px solid #d9e1f2",
};
 
 
    return (
           //2/11
           <div
     style={{
       width: "100%",
       maxWidth: "1000px",
       margin: "14px auto 0",
       background: "#EEF2F7",
       border: "1px solid #dfe5ee",
       borderRadius: "10px",
       padding: "15px 20px 20px",
       boxSizing: "border-box",
     }}
   >
       {/* //2/11 */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, padding: "0 20px", width: "100%" }}>
                       <h5 style={{ fontWeight: "bold", color: "black", display: "flex", alignItems: "center" }}>
                           <img src={"/Vendor-Report-List-32.png"} alt="icon" style={{ marginRight: 10, width: 28, height: 28 }} /> Vendor Report
                       </h5>
                       <div style={{ display: "flex", alignItems: "center", backgroundColor: "white", border: "1px solid #ccc", borderRadius: 5, padding: "5px 10px", width: 300 }}>
                           <img src={"/Search-32.png"} alt="search" style={{ width: 20, height: 20, marginRight: 8 }} />
                           <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search Vendors..." style={{ border: "none", outline: "none", background: "transparent", width: "100%", fontSize: 14 }} />
                       </div>
                   </div>
   {/* //2/11 */}
           <div style={{ background: '', width: 'auto', maxHeight: "92vh", fontFamily: 'Inter, sans-serif' }}>
                  
               <div style={{ display: "grid", justifyContent: "center", boxShadow: "0 0 10px rgba(0,0,0,0.1)", borderRadius: 20, backgroundColor: "white", padding: 20, maxHeight: "81vh", overflow: "auto" }}>
                   
   {/* 05-10 */}
                   <div style={{ overflowX: "auto", width: "100%", position: "relative"}}> 
                       {/* //2/11 */}
                      <div
     style={{
       width: "100%",
       maxHeight: "65vh",
       overflow: "auto",
       position: "relative",
       border: "1px solid #d9e1f2",
       borderRadius: "8px",
       backgroundColor: "white",
     }}
   >
     <table
       style={{
         backgroundColor: "white",
         width: "max-content",
         minWidth: "100%",
         borderCollapse: "separate",
         borderSpacing: 0,
         
       }}
     >
                           <thead >
                               {/* //28/10 */}
                               <tr style={{ backgroundColor: "#2D79D9", color: "white", fontSize: 14, fontWeight: 600, textAlign: "center", whiteSpace: "nowrap" }}>
                                    <th style={thStyle}>Vendor ID</th>
                                   <th style={thStyle}>Company Name</th>
                                   <th style={thStyle}>Address</th>
                                   <th style={thStyle}>Mobile No</th>
                                   <th style={thStyle}>Email</th>
                                   <th style={thStyle}>Pincode</th>
                                   <th style={thStyle}>City</th>
                                   <th style={thStyle}>PAN NUMBER</th>
                                   <th style={thStyle}>TAN Number</th>
                                   <th style={thStyle}>GST Number</th>
                                   <th style={thStyle}>Aadhaar Number</th>
                                   <th style={thStyle}>IFSC Code</th>
                                   <th style={thStyle}>MICR Code</th>
                                   <th style={thStyle}>Bank Name</th>
                                   <th style={thStyle}>Branch Name</th>
                                   <th style={thStyle}>Account Number</th>
                                   <th style={thStyle}>Passbook Document</th>
                                   <th style={thStyle}>Cheque Document</th>
                                   <th style={thStyle}>PAN Document</th>
                                   <th style={thStyle}>TAN Document</th>
                                   <th style={thStyle}>GST Document</th>
                                   <th style={thStyle}>Aadhaar Document</th>
                                   <th style={thStyle}>Creation Date</th>
                               </tr>
                           </thead>
                          
                         <tbody>
                                {currentBills?.map((contractor, index) => (
                                 
                              
                                      //28/10
                                           <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1", fontSize: 13, fontWeight: 500, textAlign: "center" }}>
                                               {/* //2/11 */}
                                               <td style={{ padding: '10px' , color: "blue",textAlign:"center"}}>{contractor.UniqueID}</td>
                                               <td style={{ padding: '10px' }}>{contractor.Bidder_CompanyName}</td>
                                               <td style={{ padding: '10px' }}>{contractor.Address}</td>
                                               <td style={{ padding: '10px' }}>{contractor.Mobile_No}</td>
                                               <td style={{ padding: '10px' }}>{contractor.Email}</td>
                                               <td style={{ padding: '10px' }}>{contractor.PinCode}</td>
                                               <td style={{ padding: '10px' }}>{contractor.City}</td>
                                               <td style={{ padding: '10px' }}>{contractor.PAN_No}</td>
                                               <td style={{ padding: '10px' }}>{contractor.TAN_No}</td>
                                               <td style={{ padding: '10px' }}>{contractor.GST_No}</td>
                                               <td style={{ padding: '10px' }}>{contractor.AadhaarNo}</td>
                                               <td style={{ padding: '10px' }}>{contractor.IFSC_CODE}</td>
                                               <td style={{ padding: '10px' }}>{contractor.MICR_No}</td>
                                               <td style={{ padding: '10px' }}>{contractor.BANK_NAME}</td>
                                               <td style={{ padding: '10px' }}>{contractor.BranchName}</td>
                                               <td style={{ padding: '10px' }}>{contractor.Account_Number}</td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PaasbookDoc || "-"}`} target='_blank'> {contractor.UniqueID} Passbook Copy </a></td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.ChequeDoc}`} target='_blank'> {contractor.UniqueID} Cheque Copy</a></td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PanDoc}`} target='_blank'> {contractor.UniqueID} PAN Copy</a></td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.TanDoc}`} target='_blank'> {contractor.UniqueID} TAN Copy</a></td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.GstDoc}`} target='_blank'> {contractor.UniqueID} GST Copy</a></td>
                                               <td style={{ padding: '10px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.AadharDoc}`} target='_blank'> {contractor.UniqueID} Aadhar Copy</a></td>
                                               <td style={{ padding: '10px' }}>{contractor.Date?.split('T')[0].replace(' ')}</td>
                                           </tr>
                                         ))}
                                       </tbody>
                          
                       </table>
                   
   
                   </div>
                       {/* 05-10 */}
                          {filteredBills.length === 0 && (
       <div
         style={{
           position: "absolute",
           top: "45px",                
           left: 0,
           width: "100%",
           height: "calc(61vh - 45px)",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           color: "#777",
           fontSize: "14px",
           fontWeight: 600,
           pointerEvents: "none",
           zIndex: 2,
         }}
       >
         No Data Available
       </div>
     )}
    
                   
                   </div>
   
                
   {/* previous pagination change 28/08/2026 */}
   
     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
                       <div>
                           <p style={{ fontSize: 14, color: "black" }}>
                               Showing {filteredBills?.length ? Math.min(indexOfFirstBill + 1, filteredBills?.length) : 0} to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries
                           </p>
                       </div>
                       <div
       style={{
           display: "flex",
           alignItems: "center",
           gap: "18px",
       }}
   >
       {/* Previous */}
       <button
           onClick={() =>
               setCurrentPage((prev) => Math.max(prev - 1, 1))
           }
           disabled={currentPage === 1}
           style={{
               border: "none",
               background: "transparent",
               color: currentPage === 1 ? "#999" : "#2ea4e7",
               cursor:
                   currentPage === 1 ? "not-allowed" : "pointer",
               fontSize: "13px",
               padding: 0,
               display: "flex",
               alignItems: "center",
               gap: "4px",
               opacity: currentPage === 1 ? 0.5 : 1,
           }}
       >
           <span style={{ fontSize: "20px" }}>‹</span>
           Previous
       </button>
    
       {/* Page Numbers */}
       <div
           style={{
               display: "flex",
               alignItems: "center",
               gap: "20px",
           }}
       >
           {getPageNumbers(currentPage, totalPages).map(
               (pageNumber, index) => {
    
                   // ...
                   if (pageNumber === "...") {
                       return (
                           <span
                               key={`ellipsis-${index}`}
                               style={{
                                   fontSize: "13px",
                                   color: "#444",
                               }}
                           >
                               ...
                           </span>
                       );
                   }
    
                   return (
                       <button
                           key={pageNumber}
                           onClick={() => setCurrentPage(pageNumber)}
                           style={{
                               border: "none",
                               background: "transparent",
                               padding: 0,
                               color:
                                   currentPage === pageNumber
                                       ? "#2ea4e7"
                                       : "#444",
                               cursor: "pointer",
                               fontSize: "13px",
                               fontWeight:
                                   currentPage === pageNumber
                                       ? "600"
                                       : "400",
                               textDecoration:
                                   currentPage === pageNumber
                                       ? "underline"
                                       : "none",
                           }}
                       >
                           {pageNumber}
                       </button>
                   );
               }
           )}
       </div>
    
       {/* Next */}
       <button
           onClick={() =>
               setCurrentPage((prev) =>
                   Math.min(prev + 1, totalPages || 1)
               )
           }
           disabled={
               currentPage === totalPages ||
               totalPages === 0
           }
           style={{
               border: "none",
               background: "transparent",
               color:
                   currentPage === totalPages ||
                   totalPages === 0
                       ? "#999"
                       : "#2ea4e7",
               cursor:
                   currentPage === totalPages ||
                   totalPages === 0
                       ? "not-allowed"
                       : "pointer",
               fontSize: "13px",
               padding: 0,
               display: "flex",
               alignItems: "center",
               gap: "4px",
               opacity:
                   currentPage === totalPages ||
                   totalPages === 0
                       ? 0.5
                       : 1,
           }}
       >
           Next
           <span style={{ fontSize: "20px" }}>›</span>
       </button>
   </div>
                   </div>
    
   
   
               </div>
           </div>
           </div>
       )
}

export default ContractorList
